/**
 * Initializes the mobileMenu by dynamically importing the necessary module from `@custom-writing/shared/components/mobile-menu`.
 * If the element is not found, the function exits early without further action.
 *
 * @throws Will throw an error with a descriptive message if the mobileMenu initialization fails.
 *
 * @returns A promise that resolves when the mobileMenu is successfully initialized or does nothing if the element is not found.
 */
export const initializeMobileMenu = async (
  callback?: () => void,
): Promise<void> => {
  const mobileMenuElement =
    document.querySelector<HTMLDivElement>('#mobileMenu');

  if (!mobileMenuElement) return; // Exit if the mobileMenu element is not found

  try {
    const { MobileMenu } = await import(
      '@custom-writing/shared/components/mobile-menu'
    );

    MobileMenu.init(callback);
  } catch (error: unknown) {
    // eslint-disable-next-line no-console
    console.error('🚨 Error initializing mobileMenu:', error);

    throw new Error(
      `Failed to initialize mobileMenu: ${error instanceof Error ? error.message : String(error)}`,
    );
  }
};
